<template>
  <span class="lang-switch" aria-label="Language switch">
    <span
      v-for="(lang, index) in languages"
      :key="lang.code"
      class="lang-switch__group"
    >
      <span v-if="index > 0" class="lang-switch__sep">|</span>
      <router-link
        v-if="locale !== lang.code"
        :to="lang.homePath"
        class="lang-switch__item"
      >
        {{ lang.label }}
      </router-link>
      <span
        v-else
        class="lang-switch__item is-active"
        aria-current="true"
      >
        {{ lang.label }}
      </span>
    </span>
  </span>
</template>

<script>
import siteConfig from '@/config/site';

export default {
  name: 'LanguageSwitch',
  props: {
    locale: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      languages: siteConfig.languages,
    };
  },
};
</script>

<style lang="scss" scoped>
.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 0;
  height: 34px;
  padding: 2px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  color: #303030;
  font-size: 14px;
  line-height: 1;
}

.lang-switch__group {
  display: inline-flex;
  align-items: center;
}

.lang-switch__sep {
  display: inline-block;
  width: 1px;
  height: 16px;
  margin: 0 2px;
  overflow: hidden;
  background: #d8e0ea;
  color: transparent;
}

.lang-switch__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  color: #303030;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    color: #087f5b;
    background: #ecfdf5;
    text-decoration: none;
  }
}

.lang-switch__item.is-active {
  color: #fff;
  background: #16a34a;
  box-shadow: 0 3px 8px rgba(22, 163, 74, 0.18);
}

@media screen and (max-width: 768px) {
  .lang-switch {
    height: 32px;
    font-size: 13px;
  }

  .lang-switch__sep {
    height: 14px;
  }

  .lang-switch__item {
    min-width: 34px;
    height: 26px;
    padding: 0 9px;
  }
}
</style>
